import React, { Fragment, useEffect, useState } from 'react';
import _uniqueId from 'lodash/uniqueId';
import BiHelp from './BiHelp';

const BiCheckBox = ({
    selected,
    onChange,
    onClick,
    name,
    label,
    style,
    disabled,


    help,
    helpKey,
    helpMainKey
}) => {

    const [id] = useState(() => _uniqueId('bic-'))

    const [sty, setStyle] = useState("form-check");
    const [item, setItem] = useState(false);

    useEffect(() => {
        if (style != null) {
            setStyle("form-check form-switch")
        }

    }, [style]);

    useEffect(() => {
        setItem(selected == null ? false : selected);
    }, [selected]);

    const onCBChange = (e) => {
        const { checked } = e.currentTarget;
        setItem(checked);
        onChange({ target: { name: name, value: checked } });
    }


    return (
        <Fragment>
            <div className={sty} style={{ display: "inline-block" }}>

                <input disabled={disabled ? "disabled" : ""} className="form-check-input" type="checkbox" id={id} checked={item} name={name} onChange={onCBChange} onClick={onClick} />


                <label className="form-check-label" htmlFor={id}>
                    {label}
                </label>


                {(help == true) &&
                    <BiHelp helpKey={helpKey ? helpKey : name} helpMainKey={helpMainKey ? helpMainKey : null}></BiHelp>
                }

            </div>

        </Fragment>
    );
}

export default BiCheckBox;